import { ref, watch } from 'vue'

/**
 * 하단 탭 4번째 칸 — '업무보고' 대신 '영업' 을 둘지 (사람마다 다르다, 기기에 저장).
 *
 * 하단 탭은 5칸이 꽉 찼다(홈 · 캘린더 · 업무 · 업무보고 · 더보기). 현장에서 영업을 매일 여는
 * 사람에게는 더보기를 지나 들어가는 한 번이 매번의 일이다. 그렇다고 모두의 업무보고 칸을
 * 빼앗을 수는 없어서 스스로 고르게 한다. 켜면 업무보고는 더보기 맨 위 행으로 옮겨 간다.
 */
const KEY = 'nav:sales-tab'

function read() {
  try {
    return localStorage.getItem(KEY) === 'on'
  } catch (e) {
    return false
  }
}

export const salesInTabs = ref(read())

watch(salesInTabs, (v) => {
  try { localStorage.setItem(KEY, v ? 'on' : 'off') } catch (e) { /* 사생활 모드 — 이번 세션만 */ }
})
